"use client";

/**
 * Presenter-chrome subcomponent: fragment-injection menu.
 * Pre-canned fragments that can be injected via /control/inject for
 * hostile audiences or live Q&A. Buttons styled as policy-fail since
 * each fragment represents a regulatory / commercial pushback.
 */
const FRAGMENTS = [
  "AML_FAIL",
  "SANCTIONS_HIT",
  "LOGISTICS_BELOW_THRESHOLD",
  "WEIGHT_TOLERANCE_BREACH",
  "FAB_VOLUME_30_TO_50",
  "LC_DISCREPANCY",
] as const;

export function InjectMenu({ onInject }: { onInject: (fragment: string) => void }) {
  return (
    <>
      <p className="mt-3 text-orbitra-teal-soft uppercase tracking-[0.18em]">Inject (after rewind)</p>
      <ul className="mt-1 flex flex-col gap-1">
        {FRAGMENTS.map((f) => (
          <li key={f}>
            <button
              onClick={() => onInject(f)}
              className="w-full rounded border border-policy-fail/30 bg-policy-fail/5 px-2 py-1 text-start text-policy-fail hover:bg-policy-fail/15"
            >
              ✕ {f}
            </button>
          </li>
        ))}
      </ul>
    </>
  );
}
